import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\BecomeTutorController::load
* @see app/Http/Controllers/BecomeTutorController.php:88
* @route '/become-a-tutor/load'
*/
export const load = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: load.url(options),
    method: 'post',
})

load.definition = {
    methods: ["post"],
    url: '/become-a-tutor/load',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BecomeTutorController::load
* @see app/Http/Controllers/BecomeTutorController.php:88
* @route '/become-a-tutor/load'
*/
load.url = (options?: RouteQueryOptions) => {
    return load.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BecomeTutorController::load
* @see app/Http/Controllers/BecomeTutorController.php:88
* @route '/become-a-tutor/load'
*/
load.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: load.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BecomeTutorController::addSubject
* @see app/Http/Controllers/BecomeTutorController.php:129
* @route '/become-a-tutor/add-subject'
*/
export const addSubject = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: addSubject.url(options),
    method: 'post',
})

addSubject.definition = {
    methods: ["post"],
    url: '/become-a-tutor/add-subject',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BecomeTutorController::addSubject
* @see app/Http/Controllers/BecomeTutorController.php:129
* @route '/become-a-tutor/add-subject'
*/
addSubject.url = (options?: RouteQueryOptions) => {
    return addSubject.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BecomeTutorController::addSubject
* @see app/Http/Controllers/BecomeTutorController.php:129
* @route '/become-a-tutor/add-subject'
*/
addSubject.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: addSubject.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BecomeTutorController::personalInformation
* @see app/Http/Controllers/BecomeTutorController.php:151
* @route '/become-a-tutor/personal-information'
*/
export const personalInformation = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: personalInformation.url(options),
    method: 'post',
})

personalInformation.definition = {
    methods: ["post"],
    url: '/become-a-tutor/personal-information',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BecomeTutorController::personalInformation
* @see app/Http/Controllers/BecomeTutorController.php:151
* @route '/become-a-tutor/personal-information'
*/
personalInformation.url = (options?: RouteQueryOptions) => {
    return personalInformation.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BecomeTutorController::personalInformation
* @see app/Http/Controllers/BecomeTutorController.php:151
* @route '/become-a-tutor/personal-information'
*/
personalInformation.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: personalInformation.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BecomeTutorController::servicesOffered
* @see app/Http/Controllers/BecomeTutorController.php:178
* @route '/become-a-tutor/services-offered'
*/
export const servicesOffered = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: servicesOffered.url(options),
    method: 'post',
})

servicesOffered.definition = {
    methods: ["post"],
    url: '/become-a-tutor/services-offered',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BecomeTutorController::servicesOffered
* @see app/Http/Controllers/BecomeTutorController.php:178
* @route '/become-a-tutor/services-offered'
*/
servicesOffered.url = (options?: RouteQueryOptions) => {
    return servicesOffered.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BecomeTutorController::servicesOffered
* @see app/Http/Controllers/BecomeTutorController.php:178
* @route '/become-a-tutor/services-offered'
*/
servicesOffered.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: servicesOffered.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BecomeTutorController::pricingAvailability
* @see app/Http/Controllers/BecomeTutorController.php:205
* @route '/become-a-tutor/pricing-availability'
*/
export const pricingAvailability = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pricingAvailability.url(options),
    method: 'post',
})

pricingAvailability.definition = {
    methods: ["post"],
    url: '/become-a-tutor/pricing-availability',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BecomeTutorController::pricingAvailability
* @see app/Http/Controllers/BecomeTutorController.php:205
* @route '/become-a-tutor/pricing-availability'
*/
pricingAvailability.url = (options?: RouteQueryOptions) => {
    return pricingAvailability.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BecomeTutorController::pricingAvailability
* @see app/Http/Controllers/BecomeTutorController.php:205
* @route '/become-a-tutor/pricing-availability'
*/
pricingAvailability.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pricingAvailability.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BecomeTutorController::bankDetails
* @see app/Http/Controllers/BecomeTutorController.php:228
* @route '/become-a-tutor/bank-details'
*/
export const bankDetails = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bankDetails.url(options),
    method: 'post',
})

bankDetails.definition = {
    methods: ["post"],
    url: '/become-a-tutor/bank-details',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BecomeTutorController::bankDetails
* @see app/Http/Controllers/BecomeTutorController.php:228
* @route '/become-a-tutor/bank-details'
*/
bankDetails.url = (options?: RouteQueryOptions) => {
    return bankDetails.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BecomeTutorController::bankDetails
* @see app/Http/Controllers/BecomeTutorController.php:228
* @route '/become-a-tutor/bank-details'
*/
bankDetails.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: bankDetails.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BecomeTutorController::presignedUploadUrl
* @see app/Http/Controllers/BecomeTutorController.php:255
* @route '/become-a-tutor/presigned-upload-url'
*/
export const presignedUploadUrl = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: presignedUploadUrl.url(options),
    method: 'post',
})

presignedUploadUrl.definition = {
    methods: ["post"],
    url: '/become-a-tutor/presigned-upload-url',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BecomeTutorController::presignedUploadUrl
* @see app/Http/Controllers/BecomeTutorController.php:255
* @route '/become-a-tutor/presigned-upload-url'
*/
presignedUploadUrl.url = (options?: RouteQueryOptions) => {
    return presignedUploadUrl.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BecomeTutorController::presignedUploadUrl
* @see app/Http/Controllers/BecomeTutorController.php:255
* @route '/become-a-tutor/presigned-upload-url'
*/
presignedUploadUrl.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: presignedUploadUrl.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BecomeTutorController::downloadUrl
* @see app/Http/Controllers/BecomeTutorController.php:277
* @route '/become-a-tutor/download-url'
*/
export const downloadUrl = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: downloadUrl.url(options),
    method: 'post',
})

downloadUrl.definition = {
    methods: ["post"],
    url: '/become-a-tutor/download-url',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BecomeTutorController::downloadUrl
* @see app/Http/Controllers/BecomeTutorController.php:277
* @route '/become-a-tutor/download-url'
*/
downloadUrl.url = (options?: RouteQueryOptions) => {
    return downloadUrl.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BecomeTutorController::downloadUrl
* @see app/Http/Controllers/BecomeTutorController.php:277
* @route '/become-a-tutor/download-url'
*/
downloadUrl.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: downloadUrl.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BecomeTutorController::muxUploadUrl
* @see app/Http/Controllers/BecomeTutorController.php:299
* @route '/become-a-tutor/mux-upload-url'
*/
export const muxUploadUrl = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: muxUploadUrl.url(options),
    method: 'post',
})

muxUploadUrl.definition = {
    methods: ["post"],
    url: '/become-a-tutor/mux-upload-url',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BecomeTutorController::muxUploadUrl
* @see app/Http/Controllers/BecomeTutorController.php:299
* @route '/become-a-tutor/mux-upload-url'
*/
muxUploadUrl.url = (options?: RouteQueryOptions) => {
    return muxUploadUrl.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BecomeTutorController::muxUploadUrl
* @see app/Http/Controllers/BecomeTutorController.php:299
* @route '/become-a-tutor/mux-upload-url'
*/
muxUploadUrl.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: muxUploadUrl.url(options),
    method: 'post',
})

const becomeATutor = {
    load: Object.assign(load, load),
    addSubject: Object.assign(addSubject, addSubject),
    personalInformation: Object.assign(personalInformation, personalInformation),
    servicesOffered: Object.assign(servicesOffered, servicesOffered),
    pricingAvailability: Object.assign(pricingAvailability, pricingAvailability),
    bankDetails: Object.assign(bankDetails, bankDetails),
    presignedUploadUrl: Object.assign(presignedUploadUrl, presignedUploadUrl),
    downloadUrl: Object.assign(downloadUrl, downloadUrl),
    muxUploadUrl: Object.assign(muxUploadUrl, muxUploadUrl),
}

export default becomeATutor